import { SignaturePad } from "./SignaturePad";

export function FieldInput({ field, value, onChange, colors }) {
  const fieldHeight = Number(field.h) || 36;

  // Dynamic sizing based on field height
  const fontSize = Math.max(11, Math.min(fieldHeight * 0.38, 20));
  const paddingX = Math.max(6, Math.min(fieldHeight * 0.25, 14));

  const baseClasses = `
    w-full
    rounded-md
    border
    outline-none
    transition-all
    duration-150
    bg-white/90
    text-gray-900
    placeholder:text-gray-400
    focus:ring-2
    focus:ring-offset-0
    disabled:opacity-60
  `;

  const baseStyle = {
    height: `${fieldHeight}px`,
    fontSize: `${fontSize}px`,
    paddingLeft: `${paddingX}px`,
    paddingRight: `${paddingX}px`,
    borderColor: colors.border,
    background: colors.bg,
    boxSizing: "border-box",
  };

  if (field.type === "signature") {
    return <SignaturePad value={value} onChange={onChange} width={field.w} height={field.h} colors={colors} />;
  }

  if (field.type === "checkbox") {
    return (
      <div className="flex items-center justify-center w-full" style={{ height: `${fieldHeight}px` }}>
        <input
          type="checkbox"
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          className="cursor-pointer rounded border-gray-300"
          style={{
            width: Math.max(16, fieldHeight * 0.55),
            height: Math.max(16, fieldHeight * 0.55),
            accentColor: colors.dot,
          }}
        />
      </div>
    );
  }

  if (field.type === "initials") {
    return (
      <button
        type="button"
        onClick={() => !value && onChange("-- Tap --")}
        className={`${baseClasses} flex items-center justify-center font-semibold`}
        style={{
          ...baseStyle,
          color: value ? colors.text : "#9ca3af",
          fontFamily: value ? "cursive" : "inherit",
        }}
      >
        {value || "Click to initial"}
      </button>
    );
  }

  if (field.type === "date") {
    return <input type="date" value={value || ""} onChange={(e) => onChange(e.target.value)} className={baseClasses} style={baseStyle} />;
  }

  if (field.type === "dropdown") {
    return (
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} className={`${baseClasses} cursor-pointer`} style={baseStyle}>
        <option value="">Select…</option>
        <option>Option A</option>
        <option>Option B</option>
        <option>Option C</option>
      </select>
    );
  }

  if (field.type === "number") {
    return <input type="number" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={field.placeholder || field.label} className={baseClasses} style={baseStyle} />;
  }

  return <input type="text" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={field.placeholder || field.label} className={baseClasses} style={baseStyle} />;
}
